import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { Map } from 'immutable';
import { clearActionResponse } from './../../actions/Global';
import { login } from './../../actions/Authentication';
import { passwordResetRequest } from './../../actions/PasswordReset';
import { AuthenticationForm } from './../../components';
import {
  getAuthenticationActionResponse,
  getLoadingStatus,
} from './../../selectors/Authentication';
import {
  getPasswordResetLoadingStatus,
  getPasswordResetActionResponse,
} from './../../selectors/PasswordReset';

class Authentication extends React.Component {
  render() {
    return (
      <Row type={'flex'} align={'middle'} className={'page-vertical-center-container'}>
        <Col span={24}>
          <AuthenticationForm
            login={this.props.login}
            passwordResetRequest={this.props.passwordResetRequest}
            passwordResetActionResponse={this.props.passwordResetActionResponse}
            actionResponse={this.props.AuthenticationActionResponse}
            isLoading={this.props.isLoading}
            isPasswordResetLoading={this.props.isPasswordResetLoading}
            clearActionResponse={this.props.clearActionResponse}
          />
        </Col>
      </Row>
    );
  }
}

/**
 * Maps relevant store state to props for this component.
 * @param state to be handled
 * @returns {{isLoading, confirmLoading, errorPasswordReset, errorAuthentication}}
 * manipulated from the state before sent to this component.
 */
const mapStateToProps = (state) => {
  return {
    isLoading: getLoadingStatus(state),
    isPasswordResetLoading: getPasswordResetLoadingStatus(state),
    passwordResetActionResponse: getPasswordResetActionResponse(state),
    AuthenticationActionResponse: getAuthenticationActionResponse(state),
  };
};

/**
 * Maps relevant store actions to props for this component.
 * @param dispatch actions to be handled.
 * @returns {{login: login, passwordResetRequest: passwordResetRequest, clearActionResponse: clearActionResponse}}
 * are actions that are mapped to props for this component.
 */
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      login: login,
      passwordResetRequest: passwordResetRequest,
      clearActionResponse: clearActionResponse,
    },
    dispatch
  );
};

/**
 * Proptypes validates that the state props are of expected type.
 * @type {{AuthenticationActionResponse: shim, passwordResetActionResponse: shim, isPasswordResetLoading: shim,
 * isLoading: shim, login: shim, passwordResetRequest: shim, clearActionResponse: shim}}
 */
Authentication.propTypes = {
  AuthenticationActionResponse: PropTypes.object,
  passwordResetActionResponse: PropTypes.instanceOf(Map),
  isPasswordResetLoading: PropTypes.bool,
  isLoading: PropTypes.bool,
  login: PropTypes.func,
  passwordResetRequest: PropTypes.func,
  clearActionResponse: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Authentication);
